// Utilities for deriving human-friendly titles from Inertia component names
export function formatComponentNameToTitle(name) {
  if (!name) return '';
  const parts = name.split('/');
  const lastPart = parts[parts.length - 1];
  return lastPart
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[-_]/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export const formModeValidator = (value) => ['add', 'edit', 'view', 'duplicate'].includes(value);

export const densityValidator = (value) => ['add', 'edit', 'view'].includes(value);

// Use folder name or just the page name if it is not put under sub folder
export function getAppBarTitle(componentName) {
  const title = componentName.split('/')[0];
  return title.charAt(0).toUpperCase() + title.slice(1);
}

export const getFieldLabelClass = (required = true) =>
  required ? 'cognito-field__label--required' : 'cognito-field__label';
